import { useContext } from 'react'
import Checkbox from 'ui/src/components/controls/checkbox'
import { EditPanelFieldComponentProps } from '..'
import { CONTROL_SIZE_SLIM } from '../../constants'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import { valueKeyFromField } from '../../utilities/field'
import { sharedValueFromGifs } from '../../utilities/gifs'
import { hasFieldPermission } from '../../utilities/permissions'

interface Props extends EditPanelFieldComponentProps {
    inverted?: boolean
}

export default ({ className, field, gifId, inverted = false, size = CONTROL_SIZE_SLIM }: Props) => {
    const { colors, gifs, permissions } = useContext(EditPanelContext)
    const { changeField } = useContext(EditPanelFieldContext)
    const key = valueKeyFromField(field)
    const value = sharedValueFromGifs<boolean>(gifs, key, gifId) || false

    function onChange(isChecked: boolean) {
        changeField(field, inverted ? !isChecked : isChecked)
    }

    return (
        <Checkbox
            backgroundColor={colors.controlDark}
            className={className}
            color={colors.label}
            disabled={!hasFieldPermission(field, permissions)}
            checked={inverted ? !value : value}
            outlineColor={colors.labelIcon}
            size={size}
            onChange={onChange}
        />
    )
}
